import React from 'react';
import { Element } from 'react-scroll';
import { Project } from '../Project/Project';
import './Projectcontainer.css';


export const Projectcontainer = () => {

  const projects = [
    {
      img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
      title:"Zen Clone",
      desc:"Query Resolving ",
      link:"https://majestic-yeot-68002b.netlify.app/",
    },
    {
      img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
      title:"URL Shortening",
      desc:"URL shortening using Authorization",
      link:"https://resilient-hummingbird-736fa5.netlify.app/",
    },
    {
      img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
      title:"Tirukural",
      desc:"Easy Reading of Tirukural",
      link:"https://mohan51502.github.io/day21tirukural/",
    },
    
{
  img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
  title:"Calculator",
  desc:"Calculator using Html,css,javascript",
  link:"https://mohan51502.github.io/day15taskcalculator/",

},
{
  img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
  title:"Log in",
  desc:"Authorized Login only, Admin can only add users",
  link:"https://curious-sfogliatella-094777.netlify.app/",

},
{
  img:"https://wallpapers.com/images/featured/4k-programming-3hcns7bt28muj7ih.jpg",
  title:"Nationalize API",
  desc:"Fetch the Nationalize API and Display to the User",
  link:"https://mohan51502.github.io/webcode1/",
},




  ]
  return (
    <Element className='projectcontainer' id='project'>
      <h1>Proje<span className='spantag'>ct</span></h1>
      <p>Here are the some projects which I have done for making lives of people easy.</p>
      <div className='projectcontainer_projects'>
  {
    projects.map((project,index) =>{
      return (
       
        
        <Project key= {index} img ={project.img} title ={project.title} desc ={project.desc} link ={project.link} />
       
      )
    })
  }      


      </div>
    </Element>
  )
}    